import * as React from "react";
import { merge, $ } from "glamor";
import Avatar from "material-ui/Avatar";
import { ITileSettings } from "components/product-collection/manage-tile-view/types";

interface IProps {
    brandEntities?: any;
    brandId: string;
    showBrandIcon?: boolean;
    brandNameOverride?: string;
    tileSettings?: ITileSettings;
}

const BrandField: React.FunctionComponent<IProps> = ({
    brandEntities,
    brandId,
    showBrandIcon,
    brandNameOverride,
    tileSettings,
}) => {
    const styles = React.useMemo(() => {
        return merge(
            $(" .brandInfoContainer", {
                display: "flex",
                paddingBottom: "10px",
            }),
            $(" .brandAvatar", {
                height: "64px",
                width: "64px",
                borderRadius: "50%",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center center",
                backgroundSize: "contain",
            }),
            $(" .brandNameWithAvatar", {
                lineHeight: "64px",
                height: "64px",
                fontSize: "12px",
                color: "black",
                paddingLeft: "12px",
            }),
            $(" .brandNameOverrideContainer", {
                overflow: "hidden",
            }),
            $(" .brandName", {
                lineHeight: "16px",
                fontSize: "12px",
                color: "black",
                paddingBottom: "10px",
            })
        );
    }, []);

    let brandField;

    if (tileSettings) {
        return brandNameOverride !== undefined ? (
            <div {...styles} className="brandNameOverrideContainer">
                <div className="brandName">{brandNameOverride}</div>
            </div>
        ) : null;
    }

    let brand;
    if (brandId && brandEntities && brandEntities[brandId]) {
        brand = {
            image: brandEntities && brandEntities[brandId] && brandEntities[brandId].settings.dashboard_logo_image,
            initials: brandEntities && brandEntities[brandId] && brandEntities[brandId]._initials,
            name: brandEntities && brandEntities[brandId] && brandEntities[brandId].name,
        };
    }

    if (showBrandIcon && brand) {
        let brandAvatar;
        if (brand.image) {
            brandAvatar = (
                <div
                    className="brandAvatar"
                    style={{ backgroundImage: `url(//cdn1.nuorder.com/brands/${brand.image}.png)` }}
                />
            );
        } else {
            brandAvatar = <Avatar size={64}>{brand.initials}</Avatar>;
        }
        brandField = (
            <div className="brandInfoContainer">
                {brandAvatar}
                <div className="brandNameWithAvatar">{brandNameOverride || brand.name}</div>
            </div>
        );
    } else if (brand && brand.name) {
        brandField = <div className="brandName">{brandNameOverride || brand.name}</div>;
    } else {
        brandField = <div className="brandName">{brandNameOverride || ""}</div>;
    }

    return <div {...styles}>{brandField}</div>;
};

// separate export statement so function name shows up in React DevTools
export { BrandField };
